<template>
  <div class="tw-w-full tw-flex tw-flex-col">
    <span class="tw-text-base tw-text-textMain tw-font-bold tw-py-3 tw-px-4">{{
      $t("文档")
    }}</span>
    <div class="tw-flex tw-flex-col">
      <b-row class="tw-mb-4" v-for="(item, index) in navItems" :key="index">
        <b-col :cols="12">
          <div
            class="tw-flex tw-items-center tw-cursor-pointer tw-bg-bgMain tw-py-2 tw-pl-4"
            @click="handleItemClick(item)"
          >
            <span class="tw-text-sm tw-text-textInfo">{{ item.name }}</span>
            <b-icon
              icon="chevron-right"
              class="tw-w-3 tw-h-3 tw-ml-0.5"
              style="color: #333"
            ></b-icon>
          </div>
        </b-col>
        <b-col
          :cols="12"
          v-for="(child, index2) in item.children"
          :key="index2"
        >
          <MobileSelectItem
            :item="child"
            @onSelect="handleToDetail"
            :isShowIcon="false"
            :isShowDesc="false"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { documentCategoriesApi, documentsApi } from "@/api/modules/home";
import MobileSelectItem from "./components/MobileSelectItem.vue";
export default {
  name: "MobileDocumentMenu",
  components: {
    MobileSelectItem,
  },
  data() {
    return {
      navItems: [],
      listquery: {
        pageIndex: 1,
        pageSize: 8,
        categoryId: "",
      },
    };
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    stripHtml(html) {
      const temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || "";
    },
    // 获取产品分类列表
    async getCategories() {
      documentCategoriesApi({
        pageIndex: 1,
        pageSize: 999,
      }).then(async (res) => {
        if (res.data && res.data.list) {
          // 对分类列表进行排序，将 id 为 6 的项移到最后
          let sortedList = [...res.data.list];
          const index = sortedList.findIndex((item) => item.id === 6);
          if (index !== -1) {
            const item = sortedList.splice(index, 1)[0];
            sortedList.push(item);
          }

          this.navItems = sortedList;
          for (let i = 0; i < this.navItems.length; i++) {
            const documents = await this.getDocuments(this.navItems[i]);
            this.$set(this.navItems, i, {
              ...this.navItems[i],
              children: documents,
            });
          }
        }
      });
    },
    async getDocuments(item) {
      this.listquery.categoryId = item.id;
      this.listquery.pageIndex = 1;
      this.listquery.pageSize = 8;
      try {
        const res = await documentsApi(this.listquery);
        if (res && res.data) {
          return res.data.list || [];
        }
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    handleAllDocument() {
      this.$router.push("/document");
      this.$emit("handleToDetail", null);
    },
    handleToDetail(item) {
      localStorage.setItem("detailForm", JSON.stringify(item));
      this.$emit("handleToDetail", item);
      this.$router.push(`/document/${item.id}?id=${item.id}&isApi=false`);
    },
    handleItemClick(item) {
      this.$emit("handleToDetail", null);
      this.$router.push(`/document?categoryId=${item.id}`);
    },
  },
};
</script>
<style lang="scss" scoped></style>
